// extracted by mini-css-extract-plugin
export default {"section":"UNnRZ7xvlJtKHToGSDab"};